// extracted by mini-css-extract-plugin
export default {"description":"Text_description__Xcypl","btn":"Text_btn__YpUcE","btnHidden":"Text_btnHidden__2HfDY"};